/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react"
import { Dialog, DialogContent, DialogActions } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import { SyncOutlined } from '@ant-design/icons'
import {
  StyledModalTitleContainer,
  StyledModalTitle,
  StyledDescription,
  TitleContainer,
  StyledSyncIcon,
  SourceTitle,
  SourceData,
  StyledFetchButton,
} from "./styles";
import { ModalCancelButton } from "../../components/modal_cancel_button/index"

export const FetchDataModal = ({
  open,
  handleClose,
  modalTitle,
  toastConfiguredRestaurants,
  sevenShiftConfiguredRestaurants,
  totalRestaurantCount,
  setFetchSource,
  fetchSource,
  handleFetch
}) => {

  const getRestaurantList = (data) => {
    if (data?.length === 0) {
      return ''
    }

    return data.map(item => item.name)
               .filter(Boolean)
               .join(', ');
  }

  return (
    <Dialog
      data-testid='fetch-jobs-modal'
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'
    >
      <DialogContent sx={{ padding: '10px 20px'}}>
        <StyledModalTitleContainer>
          <TitleContainer>
            <StyledSyncIcon />
            <StyledModalTitle>
              {modalTitle}
            </StyledModalTitle>
          </TitleContainer>
          <CloseIcon
            data-testid="cross-icon"
            onClick={handleClose} 
            sx={{cursor: 'pointer', color: 'grey'}}
          />
        </StyledModalTitleContainer>

        <StyledDescription>
          To trigger a manual fetch for the selected restaurants from the sources below.
        </StyledDescription>

        <div>
          <SourceTitle>
            SELECT SOURCES TO FETCH FROM
          </SourceTitle>

          {/*Toast Source */}
          {
            toastConfiguredRestaurants?.length > 0 && (
              <SourceData 
                badgeColor={'#EA580C'}
                sourceName={'Toast'}
                chipTitle={`${toastConfiguredRestaurants?.length} of ${totalRestaurantCount}`}
                restaurantList={getRestaurantList(toastConfiguredRestaurants)}
                value='toast'
                setFetchSource={setFetchSource}
                fetchSource={fetchSource}
              />
            )
          }

          {/*7 shifts source */}
          {
            sevenShiftConfiguredRestaurants?.length > 0 && (
              <SourceData 
                badgeColor={'#1976d2'}
                sourceName={'7 shifts'}
                chipTitle={`${sevenShiftConfiguredRestaurants?.length} of ${totalRestaurantCount}`}
                restaurantList={getRestaurantList(sevenShiftConfiguredRestaurants)}
                value='seven_shifts'
                setFetchSource={setFetchSource}
                fetchSource={fetchSource}
              />
            )
          }
        </div>
      </DialogContent>

      <DialogActions sx={{padding: '20px'}}>
        <ModalCancelButton
          data-testid='close-modal'
          onClick={handleClose}
        >
          Cancel
        </ModalCancelButton>
        <StyledFetchButton
          data-testid='fetch-now-btn'
          variant="contained"
          startIcon={<SyncOutlined />}
          onClick={handleFetch}
          disabled={!fetchSource?.toast && !fetchSource?.seven_shifts}
        >
          Fetch Now
        </StyledFetchButton>
      </DialogActions>
    </Dialog>
  )
}
